import { isUndefined } from 'lodash';
import { PositionDto, PrivateQuoteDto } from 'src/dtos';
import { Position, Quote } from 'src/models';

const enrichNonTradablePosition = (model: Position, privateQuote: PrivateQuoteDto): Position => {
  let result: Position = {
    ...model,
    isTradable: false,
    value: privateQuote.currentPrice,
    totalValue: model.quantity * privateQuote.currentPrice,
  };

  if (result.purchasePrice === 0) {
    result.purchasePrice = privateQuote.purchasePrice;
  }

  if (!isUndefined(privateQuote.lastPrice)) {
    result.value = privateQuote.lastPrice;
    result.totalValue = model.quantity * privateQuote.lastPrice;
  }

  return result;
};

const makeNonTradablePositionIfFound = (model: Position, privateQuotes: PrivateQuoteDto[]): Position => {
  const privateQuote = privateQuotes.find(aPrivateQuote => aPrivateQuote.symbol === model.symbol);

  if (!privateQuote) {
    return model;
  }
  let result = enrichNonTradablePosition(model, privateQuote);

  return result;
};

export const mapPositionDtoToModel = (
  dto: PositionDto,
  quotes: Quote[],
  privateQuotes: PrivateQuoteDto[],
): Position => {
  let result: Position = {
    id: dto.OrderId.toString(),
    symbol: dto.Symbol,
    name: dto.Description,
    quantity: dto.OpenQuantity,
    purchasePrice: dto.OpenPrice,
    isTradable: true,
    totalCost: dto.CostBasis,
  };
  const positionQuote = quotes.find(aQuote => aQuote.symbol === dto.Symbol);

  if (positionQuote && !isUndefined(positionQuote.last) && !isUndefined(positionQuote.change)) {
    result.value = positionQuote.last;
    result.totalValue = positionQuote.last * result.quantity;
    result.change = positionQuote.change / 100;
  }

  if (positionQuote?.description) {
    result.name = positionQuote.description;
  }

  result = makeNonTradablePositionIfFound(result, privateQuotes);

  return result;
};

export const mapPositionListDtoToModel = (
  dtos: PositionDto[],
  snap: Quote[],
  privateQuotes: PrivateQuoteDto[],
): Position[] => dtos.map(dto => mapPositionDtoToModel(dto, snap, privateQuotes));
